import React from "react";
import { Box, Paper, Typography, makeStyles } from "@material-ui/core";
import DropdownForecast from "./DropdownForecast";
import { useSelector } from "react-redux";
import GetWeatherIcon from "./GetWeatherIcon";
import GetRainIcon from "./GetRainIcon";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    color: "#000",
    padding: theme.spacing(1),
    width: "50vw",
    margin: "0 auto",
    borderRadius: theme.shape.borderRadius,
    position: "relative",
    boxShadow: "none",
    
  },
  weatherItem: {
    display: "flex",
    alignItems: "center",
    minWidth: "150px",
    
  },
  weatherItemR: {
    display: "flex",
    alignItems: "center",
    width: "100px",
    [theme.breakpoints.down(1350)]: {
      width: "100px",
    },
    
  },
  temperatureItem: {
    display: "flex",
    alignItems: "center",
    minWidth: "120px",
  },
  temperatureRange: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#666666",
    minWidth: "30px",
  },
  forecastButtonContainer: {
    display: "flex",
    justifyContent: "flex-start",
    marginTop: theme.spacing(2),
    backgroundColor: "transparent",
    width: "100%",
  },
  mainContainer: {
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  menuWrapper: {
    width: "100%",
    display: "flex",
  },
  locationName: {
    fontSize: "1rem",
    fontWeight: "bold",
    textTransform: "uppercase",
    minWidth: "150px",
    maxWidth: "200px",
    color: "#333333",
  },
  weatherIcon: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
  },
  forecastTime: {
    fontSize: "1rem",
    minWidth: "70px",
    color: "#666666",
  },
  precipitation: {
    alignItems: "center",
    fontSize: "1rem",
    minWidth: "120px",
  },
  windSpeed: {
    fontSize: "1rem",
    minWidth: "90px",
    color: "#333333",
  },
  currentTemp: {
    fontSize: "1.5rem",
    fontWeight: "Light",
    minWidth: "90px",
    color: "#263C73",
  },
  minMaxTemp: {
    fontSize: "1rem",
    color: "#666666",
  },
  boxWeather: {
    
  }
}));

export const WeatherBar = () => {
  const classes = useStyles();
  const { dataBar = {}, dataPronostico } = useSelector((state) => state.gis);
  const {
    iconoNubosidad = "sol_despejado",
    nombre = "N/A",
    jornada = "N/A",
    lluvia = "N/A",
    iconoLluvia = "tiemposecosol",
    viento = { velocidadViento: "N/A", direccionViento: "N/A" },
    temperatura = {
      temperaturaNumber: "N/A",
      temperaturaMax: "N/A",
      temperaturaMin: "N/A",
    },
  } = dataBar;

  return (
    <div className={classes.mainContainer}>
      <Paper className={classes.root}>
        <Box
        className={classes.boxWeather}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          textAlign="center"
          

        >
          <div className={classes.weatherItem}>
            <Typography variant="h6" className={classes.locationName}>
              {nombre}
            </Typography>
            <Typography variant="body2" className={classes.forecastTime}>
              {jornada}
            </Typography>
          </div>
          <div className={classes.weatherIcon}>
            <GetWeatherIcon iconoNubosidad={iconoNubosidad} />
          </div>
          <div className={classes.weatherItemR}>
            <GetRainIcon lluvia={iconoLluvia} />
          </div>
          <div className={classes.weatherItemR}>
            <Typography variant="body2" className={classes.windSpeed}>
              {viento.velocidadViento} {viento.direccionViento}
            </Typography>
          </div>
          <div className={classes.temperatureItem}>
            <Typography variant="body2" className={classes.currentTemp}>
              {temperatura.temperaturaNumber}
            </Typography>
            <div className={classes.temperatureRange}>
              <Typography variant="body2">
                ↑ {temperatura.temperaturaMax}
              </Typography>
              <Typography variant="body2">
                ↓ {temperatura.temperaturaMin}
              </Typography>
            </div>
          </div>
        </Box>
      </Paper>
      <Box className={classes.forecastButtonContainer}>
        <div className={classes.menuWrapper}>
          <DropdownForecast fullWidth dataPronostico={dataPronostico} />
        </div>
      </Box>
    </div>
  );
};

export default WeatherBar;
